import { call, put } from 'redux-saga/effects';
import DeleteMakeActions from '../redux/DeleteMakeRedux';
import { api } from './api';


export function* deletemakesagas(action: any): Generator<any, void, any> {
  const { withdrawal_id, file_id } = action;
  const response = yield call(api.deleteMake, withdrawal_id, file_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(DeleteMakeActions.deleteMakeSuccess(response.data));
  } else {
    yield put(DeleteMakeActions.deleteMakeFailure());
  }
}